/**
 * Constantes del feature Services
 */

export const TECHNOLOGY_CATEGORIES = [
  {
    titulo: "home.tecnologias.categorias.flavors",
    tecnologias: [
      { nombre: "React", logo: "/Logos tecnologias/Technology Flavors/react.svg" },
      { nombre: "Angular", logo: "/Logos tecnologias/Technology Flavors/angular-logo.svg" },
      { nombre: "Node.js", logo: "/Logos tecnologias/Technology Flavors/nodejsblanco.svg" },
      { nombre: "Java + Spring Boot", logo: "/Logos tecnologias/Technology Flavors/java-springboot.svg" },
      { nombre: "Net Core", logo: "/Logos tecnologias/Technology Flavors/NET_Core_Logo.svg" },
      { nombre: "Python", logo: "/Logos tecnologias/Technology Flavors/python-svg.svg" },
      { nombre: "Go", logo: "/Logos tecnologias/Technology Flavors/go-svg.svg" },
    ],
  },
  {
    titulo: "home.tecnologias.categorias.cloud",
    tecnologias: [
      { nombre: "AWS", logo: "/Logos tecnologias/Cloud & Infrastructure/AWS.svg" },
      { nombre: "Google Cloud", logo: "/Logos tecnologias/Cloud & Infrastructure/Google_Cloud_logo.svg" },
      { nombre: "Microsoft Azure", logo: "/Logos tecnologias/Cloud & Infrastructure/microsoft-azure.svg" },
      { nombre: "OCI", logo: "/Logos tecnologias/Cloud & Infrastructure/OCI.svg" },
      { nombre: "Red Hat", logo: "/Logos tecnologias/Cloud & Infrastructure/Red_Hat_logo.svg" },
      { nombre: "Docker & Kubernetes", logo: "/Logos tecnologias/Cloud & Infrastructure/docker -kubernetes logo.svg" },
    ],
  },
  {
    titulo: "home.tecnologias.categorias.data",
    tecnologias: [
      { nombre: "PostgreSQL", logo: "/Logos tecnologias/High-Performance & Data/postgresql-svg.svg" },
      { nombre: "MongoDB", logo: "/Logos tecnologias/High-Performance & Data/MongoDB_Spring-Green.svg" },
      { nombre: "Cloud SQL", logo: "/Logos tecnologias/High-Performance & Data/cloud-sql-logo svg.svg" },
      { nombre: "Oracle DB", logo: "/Logos tecnologias/High-Performance & Data/oracle-db.svg" },
      { nombre: "Kafka", logo: "/Logos tecnologias/High-Performance & Data/kafka-svgrepo-com.svg" },
    ],
  },
  {
    titulo: "home.tecnologias.categorias.ai",
    tecnologias: [
      { nombre: "PyTorch + TensorFlow", logo: "/Logos tecnologias/AI & Intelligence/PyTorch-TensorFlow.svg" },
      { nombre: "Machine Learning", logo: "/Logos tecnologias/AI & Intelligence/machine-learning.svg" },
      { nombre: "Generative AI", logo: "/Logos tecnologias/AI & Intelligence/artificial-intelligence-ai-icon.svg" },
    ],
  },
  {
    titulo: "home.tecnologias.categorias.delivery",
    tecnologias: [
      { nombre: "GitHub Actions", logo: "/Logos tecnologias/Delivery & Quality Assurance/GitHub Actions.svg" },
      { nombre: "GitLab", logo: "/Logos tecnologias/Delivery & Quality Assurance/gitlab-svgrepo-com.svg" },
      { nombre: "Jenkins", logo: "/Logos tecnologias/Delivery & Quality Assurance/jenkins-svg.svg" },
      { nombre: "Cypress", logo: "/Logos tecnologias/Delivery & Quality Assurance/Cypress-Icon--Streamline-Svg-Logos.svg" },
      { nombre: "Playwright", logo: "/Logos tecnologias/Delivery & Quality Assurance/Playwright--Streamline-Svg-Logos.svg" },
      { nombre: "Selenium", logo: "/Logos tecnologias/Delivery & Quality Assurance/selenium-svgrepo-com.svg" },
      { nombre: "Unit Testing", logo: "/Logos tecnologias/Delivery & Quality Assurance/unit-testing-svgrepo-com.svg" },
      { nombre: "Scrum.org", logo: "/Logos tecnologias/Delivery & Quality Assurance/scrumorg-1.svg" },
    ],
  },
  {
    titulo: "home.tecnologias.categorias.security",
    tecnologias: [
      { nombre: "OWASP ZAP", logo: "/Logos tecnologias/Security & Compliance/ZAP_logo.svg" },
      { nombre: "SonarQube", logo: "/Logos tecnologias/Security & Compliance/sonarqube-blanco-svg.svg" },
      { nombre: "OAuth", logo: "/Logos tecnologias/Security & Compliance/Oauth_logo.svg" },
      { nombre: "ISO 27001", logo: "/Logos tecnologias/Security & Compliance/logo iso27001.svg" },
      { nombre: "SSL/TLS", logo: "/Logos tecnologias/Security & Compliance/logo SSL-TLS.svg" },
    ],
  },
];

export const SERVICES_ANIMATION = {
  stagger: 0.2,
  delay: 0.1,
};
